import { connect } from "react-redux";
import ThemedApp from "./ThemedApp";
import withWidth from "material-ui/utils/withWidth";
import { setWidth } from "./actions/drawer";

const mapStateToProps = (state, ownProps) => {
  return {
    width: ownProps.width
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateGeometry: width => {
      dispatch(setWidth(width));
    }
  };
};

const ThemedAppContainer = connect(mapStateToProps, mapDispatchToProps)(
  ThemedApp
);

export default withWidth()(ThemedAppContainer);



// WEBPACK FOOTER //
// ./src/ThemedAppContainer.js